export const customSelectStyles = {
  control: (base: any) => ({
    ...base,
    minHeight: "24px",
    height: "100%",
    border: "none",
    boxShadow: "none",
    background: "transparent",
    fontSize: "0.875rem",
  }),
  menu: (base: any) => ({
    ...base,
    zIndex: 1050,
    position: "absolute",
    width: "100%",
  }),
  menuList: (base: any) => ({
    ...base,
    maxHeight: "200px",
  }),
  container: (base: any) => ({
    ...base,
    width: "100%",
    height: "100%",
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: 0,
    height: "100%",
  }),
  input: (base: any) => ({
    ...base,
    padding: 0,
    margin: 0,
  }),
  singleValue: (base: any) => ({
    ...base,
    padding: 0,
    margin: 0,
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    padding: 0,
    height: "100%",
  }),
}
